import React from 'react';
import PropTypes from 'prop-types';
import ProductFactory from 'factories/Products';

const ProductQuantity = (props) => {

    const item = props.item;
    const quantity = props.quantity;

    if(!item) return '';



    let qtyNumber = parseFloat(quantity * item.unitMultiplier).toFixed(2);
    if ((qtyNumber - Math.floor(qtyNumber)) === 0) {
        qtyNumber = Math.floor(qtyNumber);
    }
    
    let quantityUnit = ProductFactory.formatWeight(item.measurementUnit, qtyNumber);

    if(!item.unitSale || (item.unitSale === undefined)) {
        return (
            <span>{quantityUnit} <span className='in-cart-txt'>en el carro</span></span>
        )
    } else {
        return (
            <>
                <span>{quantity} un.</span><span>({quantityUnit})</span>
            </>
        )
    }



};

ProductQuantity.propTypes = {
    quantity: PropTypes.number,
    item: PropTypes.object
};

export default ProductQuantity;
